<script setup>

</script>

<template>
    <tr class="border-b"><slot/></tr>
</template>
